/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

'use strict';

;(function ($, window, document, undefined) {

    $(document).ready(function () {

        $('.inputfile').each(function () {
            var $input = $(this),
                id = $input.attr('id'),
                $label = $('label[for="' + id + '"]'),
                labelVal = $label.html();

            // javascript is active so add class to hide browser's input
            $input.addClass('js');

            $input.on('change', function (e) {
                var fileName = '';

                if (this.files && this.files.length > 1)
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                else if (e.target.value)
                    fileName = e.target.value.split('\\').pop();

                console.log(fileName);

                if (fileName)
                    $label.find('span.input-file').html(fileName);
                else
                    $label.html(labelVal);
            });

            // Firefox bug fix
            $input
                .on('focus', function () {
                    $input.addClass('has-focus');
                })
                .on('blur', function () {
                    $input.removeClass('has-focus');
                });
        });
    });

})(jQuery, window, document);
